module.exports = __webpack_public_path__ + "img/logo4.78567f09.png";